export default "__VITE_ASSET__C9Aawgi3__"